import ProductWarehouseItem from "@/models/ProductWarehouseItem";
import Model from "@/models/Model";

export default class Product extends Model {

	static type = "woocommerceProducts";

	productWarehouseItems: ProductWarehouseItem[];
	name: string;
	externalId: string;
}
